import { createApp } from 'vue'
import SortDropdown from './SortDropdown'

const el = '.kb-component--sort-dropdown'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SortDropdownDOM) => {
            const config = JSON.parse(SortDropdownDOM.dataset.config)
            const component = createApp(SortDropdown, { config }).use(Store)
            component.mount(SortDropdownDOM)
        })
    }
}
